module.exports = __webpack_public_path__ + "img/产品理念.74d6ef1d.png";